import React, { Component, createRef } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { map } from "lodash"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Flatpickr from "react-flatpickr"
import notes from "../../assets/images/rsicons/notes.png";
import follow from "../../assets/images/rsicons/follow-up.png";
import phonelog from "../../assets/images/rsicons/phone-log.png";
import emaillog from "../../assets/images/rsicons/email-log.png";
import {
  Container, Row, Col, Card, CardBody, Label, FormGroup, Input, InputGroup,
  DropdownItem, DropdownMenu, DropdownToggle, Table, UncontrolledDropdown, Offcanvas, OffcanvasHeader, OffcanvasBody, Nav, NavItem, NavLink, TabPane, TabContent, CardTitle,
  CardHeader,
  Button
} from "reactstrap"
import FilterMenu from "./filter-menu/filter-menu";
import {
  addLeadNoteTab, getLeads, getNoteLeadTab, getListLeadTab, addFollowNoteTab, getFollowLeadTab,
  getLeadCallLog, addLeadCallLog, addLeadEmailLog, getLeadEmailLog, getAllActLeadTab, deleteLead, addActivityFollowUp,
  getActivityFollowUp, getCampLeadList,
  getCampaignEmailList
} from "../../store/actions"
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import classnames from "classnames"
import CreateLead from './forms/lead-create'
import RsAdNew from "components/buttons/Adnew";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from 'moment';
import axios from "axios";
import { API_URL } from "helpers/app_url";
import Swal from 'sweetalert2';
import ActionEditLink from "components/buttons/actionEditlink";
import ActionActivity from "components/buttons/actionActivity";
import TimePicker from "components/dropdowns/Timepicker";
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import RsLink from "components/buttons/rsLink";
import { reset } from "redux-form";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class LeadListShort extends Component {
  constructor(props) {
    super(props)
    this.state = {
      leads: [],
      lead: '',
      activeTab3: "2",
      selectedLeads: [],
      leadMessages: [],
       expandedRows: null, 
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);

    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.isAllCanavas = this.isAllCanavas.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this)
     this.dt = createRef();
  }
    handleSubmit = (value, { resetForm }) => {
        const payload = {
          messageFromId: parseInt(value.messageFromId),
          messageToId: parseInt(value.messageToId),
          messageFrom: value.messageFrom,
          messageTo: value.messageTo,
          messageText: value.messageText,
          agentId: parseInt(value.agentId),
          isActive: true,
        }
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const url = `${API_URL}LeadMessage`;
        toast.loading("Please wait...");
        axios
          .post(url, payload, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.success) {
              toast.dismiss();
              toast.success("Saved successfully.");
              resetForm();
              this.fetchLeadMessage(value.messageToId);
            } else {
              toast.dismiss();
              toast.error('some issue while sending message');
              console.warn("Submission failed:", response.data);
            }
          })
          .catch((error) => {
            console.error("Error sending message:", error);
    
          });
      }

  fetchLeadMessage(leadId) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const params = {
        LeadId: leadId,
        agentId : localStorage.getItem('userId')
      };
      axios
        .get(`${API_URL}LeadMessage/allLead`, { headers, params })
        .then((response) => {
          this.setState({ leadMessages: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
       });
    }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue('activityLocation', place.formatted_address);
        setFieldValue('activityLatitude', longitude);
        setFieldValue('activityLongitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('startTime', formattedTime);

  };

  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('endTime', formattedTime);

  };
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleAllCanavas() {
    this.setState(prevState => ({
      isAll: !prevState.isAll,
       activeTab3: !prevState.isAll ? "2" : prevState.activeTab3,
    }));
  }
  isAllCanavas() {
    this.setState({ lead: "", isAll: !this.state.isAll });
    this.toggleAllCanavas();
  }
  isAllCanavas = arg => {
    const lead = arg;
    const {  onGetAllActLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.id,
        contactName: lead.firstName + " " + lead.lastName,
        email: lead.email,
        mobile: lead.mobile
      },
    });
  
    onGetAllActLead(lead.id)
    this.toggleAllCanavas();
  };
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (lead) => {
    this.setState({ lead: lead });
    this.setState({ deleteModal: true });
  };

  handleDeleteLead = () => {
    const { onDeleteLead } = this.props;
    const { lead } = this.state;

    if (lead.id !== undefined) {
      onDeleteLead(lead);
      this.setState({ deleteModal: false });
    }
  };

  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));

  }

  addNewtoggle() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }

  componentDidMount() {
    const { onGetAllLeads, onGetCampaignEmailList } = this.props;
    onGetAllLeads(localStorage.getItem('userId'), 0);
    onGetCampaignEmailList(localStorage.getItem('userId'));
  }
  toggleEmailCanvas = arg => {
    const lead = arg;
    const { onGetAllActLead } = this.props;
     if (lead) {
    
    this.setState({
      lead: {
        id: lead.id,
      },
      isEdit: true,
    });
    onGetAllActLead(arg.id);
  }
    //onGetAllActLead(lead.id)
    this.toggle();
  };


  filterTable = (event) => {
    this.setState({ tableFilter: event.target.value });
  };

  handleBulkDelete = () => {
    const { selectedLeads } = this.state;

    if (selectedLeads.length === 0) return;

    Swal.fire({
      title: 'Delete Selected Leads?',
      text: `You are about to delete ${selectedLeads.length} lead(s). This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete them!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const idsToDelete = selectedLeads.map((lead) => lead.id);
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj.resultData.bearerToken;
        const str = "Bearer " + token;
        const headers = {
          Authorization: str,
          'Content-Type': 'application/json',
        };
       axios.post(`${API_URL}Lead/bulkDeleteLeads`, selectedLeads.map(lead => lead.id), { headers })
          .then((response) => {
            Swal.fire({
              title: 'Deleted!',
              text: `${idsToDelete.length} lead(s) have been deleted.`,
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
            });
            this.setState({ selectedLeads: [] });
            // Optionally, reload lead list
            this.props.onGetAllLeads(localStorage.getItem('userId'));
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong while deleting leads.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
            console.error('Bulk delete error:', error);
          });
      }
    });
  };
  
  render() {
    const { onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog, onSendWorksheetEmailLog, allLeads, gridLoading, userdetail, campaignemaillists } = this.props;
    const { leadNotes, leadFollows, calllogs, emaillogs, activities } = this.props;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const lead = this.state.lead;
    const userModule = localStorage.getItem('userModule');
    const { isEdit, isEditFollow, isEditCall, isEditEmail, deleteModal, leadMessages } = this.state;
    const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
    
    const sourceOptions = Object.keys(localization)
  .filter((key) => key.startsWith("LeadSource_"))
  .map((key) => ({
    label: localization[key],
    value: parseInt(key.replace("LeadSource_", ""), 10),
  }));


  const statusOptions = Object.keys(localization)
  .filter((key) => key.startsWith("LeadStatus_"))
  .map((key) => ({
    label: localization[key],
    value: parseInt(key.replace("LeadStatus_", ""), 10),
  }));



   const leadsWithFullName = this.props.allLeads.map((lead) => ({
      ...lead,
      fullName: `${lead.firstName ?? ""} ${lead.lastName ?? ""}`,
    }));

    //
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        {gridLoading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteLead}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="">

          <Container fluid className="ps-0">
            <ToastContainer autoClose={2000} />


            <Row>
              <Col lg="12">
                <Card className="border-full mt-4">
                  <CardHeader>
                    <div className="row">
                      <div className="col-sm-8">
                          <FilterMenu />
                      </div>
                      <Col sm="2">
                      <select
                          className="form-select form-control"
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            const { onGetAllLeads } = this.props;
                            onGetAllLeads(localStorage.getItem('userId'), selectedValue);
                          }}
                        >
                          <option value="0">All</option>
                          {campaignemaillists?.map((campaignemaillist, index) => (
                            <option key={index} value={campaignemaillist.id}>
                              {campaignemaillist.campaignEmailListName}
                            </option>
                          ))}
                        </select>

                      </Col>
                       <div className="col-sm-2">
                                              <div className="input-group">
                      
                                                <Input type="text" className="form-control search-bx" id="autoSizingInput"
                                                  value={this.state.tableFilter}
                                                  onInput={this.filterTable}
                                                  placeholder="Search By Name, Phone, Email" />
                                                <span className="input-group-text search-btn" id="basic-addon1">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                                                  </svg>
                                                </span>
                                              </div>
                      
                                            </div>
                   
                    </div>
                  </CardHeader>
                  <CardBody>
                  
                    
                    <div className="row">

                      <div className="col-sm-4">
                         {this.state.selectedLeads.length > 0 && (
                          <button className="btn btn-add mb-3" onClick={this.handleBulkDelete}>
                           <i className="bx bx-trash"></i> ({this.state.selectedLeads.length})
                          </button>
                        )}
                      </div>

                      <div className="col-sm-4">
                    

                      </div>
                      <div className="col-sm-4">
                       
                      </div>

                    </div>
                    <div className="clearfix"></div>
                    <div className="datatable-loading">
                      <div className="d-none d-md-block">
                      
                     <DataTable className="" stripedRows value={leadsWithFullName} paginator rows={10}
                         ref={this.dt}
                        rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries "
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   "
                        tableStyle={{ minWidth: '50rem' }}
                        globalFilter={this.state.tableFilter}
                        dataKey="id"
                        selection={this.state.selectedLeads}
                        onSelectionChange={(e) => this.setState({ selectedLeads: e.value })}
                        rowClassName={(rowData) => rowData.onlyInterestedPreConsProject ? 'highlight-row' : ''}
                        filterDisplay="menu"
                        
                      >
                        <Column selectionMode="multiple" headerStyle={{ width: '3em' }} filter={false} />
                         <Column
    header="#"
    body={(rowData, options) => options.rowIndex + 1}
    style={{ width: '60px' }}
  />
                        <Column headerClassName="align-middle" bodyClassName="table-data" field="fullName" header="Name"
                            filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false}            
                        body={(rowData) => (
                          <div className="row">
                            <div className="col-sm-10"><Link  to={"/lead/lead-detail/" + rowData.id + "/" + rowData.leadId}>{rowData.firstName} {rowData.lastName}</Link> </div>
                          
                          </div>
                        )}></Column>
                 
                        <Column field="lastContact" header="Submitted Date" body={(rowData) => (
                          rowData.submittedDate ? <Moment format="D MMM YY">{rowData.submittedDate}</Moment> : 'N/A'
                        )}></Column>
                        <Column field="mobile" header="Mobile"
                         filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false} 
                        ></Column>
                        <Column field="email" header="Email"
                         filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false} 
                        ></Column>
                        <Column field="lastContact" header="Last Contact" body={(rowData) => (
                          rowData.lastContact ? <Moment format="D MMM YY">{rowData.lastContact}</Moment> : 'N/A'
                        )}></Column>
                        <Column field="leadSourceId" header="Source" 
                        //showFilterMenu={false}
                            
                            filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false}          
                            filterMatchMode="in" 
                            filterElement={(options) => (
                               <MultiSelect
                                  value={options.value}
                                  options={sourceOptions}
                                  onChange={(e) => options.filterApplyCallback(e.value)}
                                  placeholder="Source"
                                  display="chip"
                                  optionLabel="label"
                                  className="p-column-filter"
                                />
                            )}
                        body={(rowData) => (
                          rowData.leadSourceId ? localization["LeadSource_" + rowData.leadSourceId] : 'N/A'
                        )}></Column>
                        <Column field="leadStatusId" header="Status"
                        filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false}          
                            filterMatchMode="in" 
                            filterElement={(options) => (
                               <MultiSelect
                                  value={options.value}
                                  options={statusOptions}
                                  onChange={(e) => options.filterApplyCallback(e.value)}
                                  placeholder="Status"
                                  display="chip"
                                  optionLabel="label"
                                  className="p-column-filter"
                                />
                         )}
                        body={(rowData) => (
                          rowData.leadStatusId > 1 ? localization["LeadStatus_" + rowData.leadStatusId] : 'N/A'
                        )}></Column>

                         <Column field="leadQualificationPoints" header="Eligibility" body={(rowData) => (
                              Math.round(rowData.leadQualificationPoints)+"%"
                        )}></Column>
                        <Column
                        headerClassName="action-header" 
                          header={
                                                <div className="justify-content-end">
                                                  <RsLink
                                                    onClick={() => this.dt.current.reset()}
                                                    iconClass="bx bx-reset"
                                                    className="btn-light"
                                                  >
                                                   Reset all filters
                                                  </RsLink>
                                                </div>
                                              }
                        body={(rowData) => (
                          <>
                            {hasPermission("RealtorLeads", "View") && (
                            <ActionEditLink to={"/lead/lead-detail/" + rowData.id + "/" + rowData.leadId} />
                            )}

                             {/* <ActionActivity to="#" onClick={() => this.isAllCanavas(rowData)} /> */}
                                {hasPermission("RealtorLeads", "Delete") && (
                              <ActionDelete onClick={() => this.onClickDelete(rowData)} />
                                )}
                          
                          </>
                        )}></Column>
                      </DataTable>
                    </div>
                     


{/* Mobile version */}
<div className="d-block d-md-none">
   <DataTable
  value={leadsWithFullName}
  dataKey="id"
  selection={this.state.selectedLeads}
  onSelectionChange={(e) => this.setState({ selectedLeads: e.value })}
  responsiveLayout="stack"
  expandedRows={this.state.expandedRows}                     
  onRowToggle={(e) => this.setState({ expandedRows: e.data })} 
  paginator
  rows={10}
 rowExpansionTemplate={(rowData) => (
  <table className="table table-bordered mb-0">
    <tbody>
      <tr>
        <th style={{ width: '40%' }}>Email</th>
        <td>{rowData.email || 'N/A'}</td>
      </tr>
      <tr>
        <th>Submitted Date</th>
        <td>
          {rowData.submittedDate ? (
            <Moment format="D MMM YY">{rowData.submittedDate}</Moment>
          ) : (
            'N/A'
          )}
        </td>
      </tr>
      <tr>
        <th>Last Contact</th>
        <td>
          {rowData.lastContact ? (
            <Moment format="D MMM YY">{rowData.lastContact}</Moment>
          ) : (
            'N/A'
          )}
        </td>
      </tr>
      <tr>
        <th>Source</th>
        <td>
          {rowData.leadSourceId ? localization["LeadSource_" + rowData.leadSourceId] : 'N/A'}
        </td>
      </tr>
      <tr>
        <th>Status</th>
        <td>
          {rowData.leadStatusId > 1 ? localization["LeadStatus_" + rowData.leadStatusId] : 'N/A'}
        </td>
      </tr>
      <tr>
        <th>Eligibility</th>
        <td>{Math.ceil(rowData.leadQualificationPoints)}%</td>
      </tr>
    </tbody>
  </table>
)}

>
  {/* Expander column */}
  <Column expander style={{ width: '3em' }} />
  <Column
    header="#"
    body={(rowData, options) => options.rowIndex + 1}
    style={{ width: '60px' }}
  />
  {/* Name */}
  <Column
    field="fullName"
    header="Name"
    body={(rowData) => (
      <Link to={`/lead/lead-detail/${rowData.id}/${rowData.leadId}`}>
        {rowData.firstName} {rowData.lastName}
      </Link>
    )}
  />

  {/* Mobile Phone */}
  <Column field="mobile" header="Mobile" />
</DataTable>

  </div>



                      <Offcanvas
                        isOpen={this.state.isAll}
                        direction="end"
                        toggle={this.isAllCanavas}
                        style={{ width: 800 }}
                        s
                      >
                        <OffcanvasHeader className="submittedWorksheet" toggle={this.isAllCanavas}>
                          Activities
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Nav pills className="navtab-bg nav-justified">
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "2",
                                })}
                                onClick={() => {
                                  this.toggle3("2");
                                  onGetAllActLead(lead.leadId)
                                }}
                              >
                                All Activities
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "1",
                                })}
                                onClick={() => {
                                  this.toggle3("1");
                                  onGetFollowLead(lead.leadId);
                                }}
                              >
                                Follow Up
                              </NavLink>
                            </NavItem>
                             {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (       
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "3",
                                })}
                                onClick={() => {
                                  this.toggle3("3");
                                  this.fetchLeadMessage(lead.leadId)
                                }}
                              >
                                Message
                              </NavLink>
                            </NavItem>
                             )}
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "4",
                                })}
                                onClick={() => {
                                  this.toggle3("4");
                                  onGetNoteLead(lead.leadId);
    
                                }}
                              >
                                Add Notes
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "5",
                                })}
                                onClick={() => {
                                  this.toggle3("5");
                                  onGetLeadCallLog(lead.leadId);
   
                                }}
                              >
                                Call Log
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "6",
                                })}
                                onClick={() => {
                                  this.toggle3("6");
                                   onGetLeadEmailLog(lead.leadId);
                                }}
                              >
                                Email Log
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent
                            activeTab={this.state.activeTab3}
                            className="p-3 text-muted"
                          >
                            <TabPane tabId="1">
                              <Formik
                                enableReinitialize={true}
                                initialValues={{
                                  agentId: parseInt(localStorage.getItem("userId")),
                                  title: "Call log",
                                  contactname: lead.contactName,
                                  contactphone: lead.mobile,
                                  contactemail: lead.email,
                                  //addedDate: new Date(),
                                  activityStartDate: new Date(),
                                  startTime: "",
                                  endTime: "",
                                  activityStatus: 1,
                                  activityType: 3,
                                  activityRefId: lead.leadId,
                                  activityDescription: (this.state && this.state.activityDescription) || "",
                                  activityLocationType: 3,
                                  activityLocation: "",

                                  isActive: true,
                                  category: 3
                                }}
                                validationSchema={Yup.object().shape({
                                    activityDescription: Yup.string().required("This is Required"),
                                    startTime: Yup.string().when('activityType', {
                                      is: (val) => parseInt(val) === 1,
                                      then: Yup.string().required("Start Time is Required"),
                                      otherwise: Yup.string().nullable()
                                    }),
                                    
                                    endTime: Yup.string().when('activityType', {
                                      is: (val) => parseInt(val) === 1,
                                      then: Yup.string().required("End Time is Required"),
                                      otherwise: Yup.string().nullable()
                                    })

                                })}
                                onSubmit={(values) => {
                                  const formattedValues = {
                                    ...values,
                                    activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),

                                  };
                                  onAddLeadFollowUp(formattedValues)
                                  //this.toggleAllCanavas();


                                }}
                              >
                                {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched  }) => (
                                  <Form
                                    className="needs-validation"
                                  >

                                    <Row>
                                      <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="builderName">
                                            {this.props.t("Select Type")}
                                          </Label>
                                          <div className="clearfix"></div>
                                          <div className="btn-group" role="group">
                                            <SafeField type="radio" className="btn-check"
                                              name="activityType" id="btnradio4"
                                              value={3}
                                              checked={values.activityType === 3}
                                              onChange={() => {
                                                setFieldValue("activityType", 3)
                                                setFieldValue("title", "Call Log")
                                              }}
                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>

                                            <SafeField type="radio" className="btn-check" name="activityType" id="btnradio5" value={10}
                                              checked={values.activityType === 10}

                                              onChange={() => {
                                                setFieldValue("activityType", 10)
                                                setFieldValue("title", "Message")
                                              }}

                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="btnradio5">Message</label>

                                            <SafeField type="radio" className="btn-check" name="activityType" id="btnradio6"
                                              value={4}
                                              checked={values.activityType === 4}

                                              onChange={() => {
                                                setFieldValue("activityType", 4)
                                                setFieldValue("title", "Email")
                                              }}
                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="btnradio6">Email</label>

                                            <SafeField type="radio" className="btn-check" name="activityType" id="btnradio7" value={1}
                                              checked={values.activityType === 1}

                                              onChange={() => {
                                                setFieldValue("activityType", 1)
                                                setFieldValue("title", "Meeting")
                                              }}

                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="btnradio7">Meeting</label>
                                          </div>
                                          <ErrorMessage
                                            name="activityType"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="12">
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="activityDescription">
                                              {this.props.t("Description *")}
                                            </Label>
                                          <SafeField
                                            name="activityDescription"
                                            onChange={handleChange}
                                            as="textarea"
                                            className={
                                              "form-control" +
                                              (errors.activityDescription && touched.activityDescription
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id="activityDescription"
                                          />
                                          <ErrorMessage
                                            name="activityDescription"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>

                                      <Col md="12">
                                        <FormGroup className="mb15">

                                          <Label htmlFor="activityStartDate">
                                            Date
                                          </Label>
                                          <Flatpickr
                                            className={
                                              "form-control" +
                                              (errors.activityStartDate && touched.activityStartDate
                                                ? " is-invalid"
                                                : "")
                                            }
                                            placeholder=""
                                            value={values.activityStartDate}
                                            onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                            options={{
                                              altInput: true,
                                              altFormat: "F j, Y",
                                              dateFormat: "Y-m-d",
                                              minDate: "today" 
                                            }}
                                          />
                                          <ErrorMessage
                                            name="logDate"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>

                                      </Col>
                                      {values.activityType === 1 && (
                                        <>
                                          <Col md="6">
                                           <TimePicker
                                              name="startTime"
                                              label="Start Time *"
                                              value={values.startTime}
                                              onChange={(val) => setFieldValue("startTime", val)}
                                              onBlur={() => setFieldTouched("startTime", true)}
                                              minTime={null}
                                              error={errors.startTime}
                                              touched={touched.startTime}
                                            />

                                             {errors.startTime && touched.startTime && (
                                                  <div className="invalid-feedback">{errors.startTime}</div>
                                              )}
                                          </Col>

                                          <Col md="6">
                                             <TimePicker
                                                  name="endTime"
                                                  label="End Time *"
                                                  value={values.endTime}
                                                  onChange={(val) => setFieldValue("endTime", val)}
                                                  onBlur={() => setFieldTouched("endTime", true)}
                                                  minTime={values.startTime}
                                                  disabled={!values.startTime}
                                                  error={errors.endTime}
                                                  touched={touched.endTime}
                                                />
                                          </Col>
                                             <Col md="12">
                                                        <FormGroup className="mb-3">
                                                         
                                                          <div className="btn-group" role="group">
                                                           <SafeField
                                                              type="radio"
                                                              className="btn-check"
                                                              name="activityLocationType"
                                                              id="btnradio9"
                                                              value={3}
                                                              checked={values.activityLocationType === 3}
                                                              onChange={() => setFieldValue("activityLocationType", 3)}
                                                              autoComplete="off"
                                                            />
                                                            <label className="btn btn-outline-secondary" htmlFor="btnradio9">
                                                              In-person
                                                            </label>
                                          
                                                            <SafeField
                                                              type="radio"
                                                              className="btn-check"
                                                              name="activityLocationType"
                                                              id="btnradio10"
                                                              value={1}
                                                              checked={values.activityLocationType === 1}
                                                              onChange={() => setFieldValue("activityLocationType", 1)}
                                                              autoComplete="off"
                                                            />
                                                            <label className="btn btn-outline-secondary" htmlFor="btnradio10">
                                                              Online
                                                            </label>
                                                          </div>
                                                        </FormGroup>
                                                      </Col>
                                        

                                          <Col md="12">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor="addressLine1">
                                                {this.props.t("Location")}
                                              </Label>
                                              {values.activityLocationType === 3 ? (
                                                <PlacesAutocomplete
                                                  value={values.activityLocation}
                                                  onChange={(value) => setFieldValue('activityLocation', value)}
                                                  onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                                >
                                                  {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                    <div>
                                                      <input
                                                        {...getInputProps({
                                                          placeholder: 'Enter Address...',
                                                          className: 'form-control',

                                                        })}
                                                      />
                                                      <div className="">
                                                        {loading ? <div>Loading...</div> : null}

                                                        {suggestions.map((suggestion, i) => {
                                                          const className = suggestion.active
                                                            ? 'suggestion-item--active'
                                                            : 'suggestion-item';
                                                          const style = suggestion.active
                                                            ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                            : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                          return (
                                                            <div
                                                              key={i}
                                                              {...getSuggestionItemProps(suggestion, {
                                                                style,
                                                              })}
                                                            >
                                                              {suggestion.description}
                                                            </div>
                                                          );
                                                        })}
                                                      </div>
                                                    </div>
                                                  )}
                                                </PlacesAutocomplete>
                                              ) : (
                                                <SafeField
                                                  name="activityLocation"
                                                  onChange={handleChange}
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.activityLocation && touched.activityLocation
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                  id="activityLocation"

                                                />
                                              )}
                                            </FormGroup>
                                          </Col>
                                        </>
                                      )}
                                    </Row>

                                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                                  </Form>
                                )}
                              </Formik>
                             {leadFollows && leadFollows.length > 0 ? (
                                <>
                                  <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                                  <ul className="verti-timeline list-unstyled">
                                    {map(leadFollows, (follLog, follLogkey) => (
                                      <li className="event-list eventlist" key={`_note_${follLogkey}`}>
                                        <div className="event-timeline-dot">
                                          <i className="bx bx-right-arrow-circle font-size-18" />
                                        </div>
                                        <div className="d-flex">
                                          <div className="flex-shrink-0 me-3">
                                            <h5 className="font-size-14">
                                              <Moment format="D MMM YY">{follLog.activityStartDate}</Moment>
                                            </h5>
                                          </div>
                                          <div className="flex-grow-1">
                                            <h5 className="font-size-14">{follLog.displayTitle}</h5>
                                          </div>
                                        </div>
                                        <div className="exNote">{follLog.activityDetails}</div>
                                      </li>
                                    ))}
                                  </ul>
                                </>
                              ) : null}

                            </TabPane>
                            <TabPane tabId="2">
                                <div className="tabContent">
                                  {activities && activities.length > 0 ? (
                                    <ul className="verti-timeline list-unstyled">
                                      {map(activities, (allactivity, allactkey) => {
                                        // Choose icon based on activitySubType
                                        let icon;
                                        if ([8, 9, 7].includes(allactivity.activitySubType)) {
                                          icon = emaillog;
                                        } else if ([3, 4, 5].includes(allactivity.activitySubType)) {
                                          icon = phonelog;
                                        } else if (allactivity.activitySubType === 10) {
                                          icon = follow;
                                        } else {
                                          icon = notes;
                                        }

                                        return (
                                          <li className="event-list eventlist" key={`_allact_${allactkey}`}>
                                            <div className="event-timeline-dot">
                                              <img src={icon} alt="activity-icon" />
                                            </div>
                                            <div className="d-flex">
                                              <div className="flex-shrink-0 me-3">
                                                <h5 className="font-size-14">
                                                  <Moment format="D MMM YY">{allactivity.addedDate}</Moment>
                                                </h5>
                                              </div>
                                              <div className="flex-grow-1">
                                                <h5 className="font-size-14">
                                                  {
                                                    localization[
                                                      `ActivitySubType_${allactivity.activityType}_${allactivity.activitySubType}`
                                                    ]
                                                  }
                                                </h5>
                                              </div>
                                            </div>
                                            <div className="exNote">{allactivity.activityRemarks}</div>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  ) : (
                                    <div className="text-muted text-center py-3">No activity recorded as yet.</div>
                                  )}
                                </div>


                            </TabPane>
                              {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (              
                            <TabPane tabId="3">
                              <div className="tabContent">
                                <Formik
                                                        enableReinitialize={true}
                                                        initialValues={{
                                                          messageFromId: localStorage.getItem("userId"),
                                                          messageToId: lead.leadId,
                                                          messageFrom: 'Realtor',
                                                          messageTo: 'lead',
                                                          messageText: '',
                                                          agentId: localStorage.getItem("userId"),
                                                          isActive: true,
                                                          
                                                        
                                                        }}
                                                        validationSchema={Yup.object().shape({
                                                            messageText: Yup.string().max(500, 'This filed contains only 500 characters only').required("This is Required")
                                                        })}
                                
                                                        onSubmit={this.handleSubmit}
                                                      >
                                                        {({ errors,  touched, values, handleChange, setFieldValue }) => (
                                                          <Form
                                                            className="needs-validation"
                                                          >
                                                          
                                                                  <Row>
                                                                    <Col md="12">
                                                                      <FormGroup className="mb-3">
                                                                        <Label htmlFor="addNote" className="w-100">
                                                                          Add Message *
                                                                        </Label>
                                                                        <SafeField
                                                                          name="messageText"
                                                                          onChange={handleChange}
                                                                          // placeholder="only 500 Characters are allowed"
                                                                          as="textarea"
                                                                          className={
                                                                            "form-control" +
                                                                            (errors.messageText && touched.messageText
                                                                              ? " is-invalid"
                                                                              : "")
                                                                          }
                                                                          id="messageText"
                                                                        />
                                                                         <ErrorMessage
                                                                              name="messageText"
                                                                              component="div"
                                                                              className="invalid-feedback"
                                                                            />
                                                                      </FormGroup>
                                                                    </Col>
                                                                  </Row>
                                                                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>
                                
                                
                                                                  </Form>
                                                        )}
                                                      </Formik>
                                                        {leadMessages && leadMessages.length > 0 ? (
                                                              <>
                                                                <div className="mb-5 h4 card-title mt-20">Message History</div>
                                                                <ul className="verti-timeline list-unstyled">
                                
                                                                  {map(leadMessages, (noteLog, notekey) => (
                                
                                                                    <li className="event-list eventlist" key={"_note_" + notekey}>
                                                                      <div className="event-timeline-dot">
                                                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                                                      </div>
                                                                      <div className="d-flex">
                                                                        <div className="flex-shrink-0 me-3">
                                                                          <h5 className="font-size-14">
                                                                            <Moment format="D MMM YY">{noteLog.createdDate}</Moment>
                                
                                
                                                                          </h5>
                                                                        </div>
                                                                        <div className="flex-grow-1">
                                                                          <h5 className="font-size-14"></h5>
                                                                        </div>
                                                                      </div>
                                                                      <div className="exNote">{noteLog.messageText}</div>
                                                                    </li>
                                                                  ))}
                                
                                                                </ul>
                                                          </>
                                                           ) : null}
                              </div>
                            </TabPane>
                              )}
                            <TabPane tabId="4">
                              <div className="tabContent">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{

                                    refId: lead.leadId,
                                    addNote:  "",



                                  }}
                                  validationSchema={Yup.object().shape({
                                    addNote: Yup.string().required("This is Required")
                                  })}

                                 onSubmit={(values, { resetForm }) => {
                                
                                    onAddLeadNote(values);
                                
                                    resetForm(); 
                                  }}
                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                      className="needs-validation"
                                    >

                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="addNote">
                                              {this.props.t("Add Note *")}
                                            </Label>
                                           <SafeField
                                            name="addNote"
                                            onChange={handleChange}
                                            
                                            as="textarea"
                                              className={
                                                "form-control" +
                                                (errors.addNote && touched.addNote
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              id="addNote"
                                            />
                                            <ErrorMessage
                                              name="addNote"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                                    </Form>
                                  )}
                                </Formik>
                                  {leadNotes && leadNotes.length > 0 ? (
                                                              <>
                                <div className="mb-5 h4 card-title mt-20">Notes History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(leadNotes, (noteLog, notekey) => (

                                    <li className="event-list eventlist" key={"_note_" + notekey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14"></h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{noteLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>
                                </>
                                  ) : null}
                              </div>
                              

                            </TabPane>
                            <TabPane tabId="5">
                              <div className="tabContent">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    actionType: 'Call',
                                    addedDate: new Date(),
                                    refId: lead.leadId,
                                    callNote: ''


                                  }}
                                  validationSchema={Yup.object().shape({
                                    actionType: Yup.string().required(
                                      "Please Select Action"
                                    ),
                                    // callNote: Yup.string().required(
                                    //   "Enter Note"
                                    // ),
                                  })}

                                  onSubmit={values => {
                                    onAddCallLog(values)
                                    //this.toggleAllCanavas();
                                  }}
                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                      className="needs-validation"
                                    >

                                      <Row className="mt20 mb20">

                                         <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="builderName">
                                            {this.props.t("Select Type")}
                                          </Label>
                                          <div className="clearfix"></div>
                                          <div className="btn-group" role="group">
                                            <SafeField type="radio" className="btn-check"
                                              name="actionType" id="actionType1"
                                              value='Call'
                                              checked={values.actionType === 'Call'}
                                              onChange={() => {
                                                setFieldValue("actionType", 'Call')
                                               
                                              }}
                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="actionType1">Call</label>

                                            <SafeField type="radio" className="btn-check"   name="actionType" id="actionType2" value='No Answer'
                                              checked={values.actionType === 'No Answer'}

                                              onChange={() => {
                                                setFieldValue("actionType", 'No Answer')
                                
                                              }}

                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="actionType2">No Answer</label>

                                            <SafeField type="radio" className="btn-check" name="actionType" id="actionType3"
                                              value={4}
                                              checked={values.actionType === 'Left Voicemail'}

                                              onChange={() => {
                                               
                                                setFieldValue("actionType", "Left Voicemail")
                                              }}
                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="actionType3">Left Voicemail</label>

                                            <SafeField type="radio" className="btn-check" name="actionType" id="actionType4" value='Bad Number'
                                              checked={values.actionType === 'Bad Number'}

                                              onChange={() => {
                                                setFieldValue("actionType", 'Bad Number')
                                               
                                              }}

                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="actionType4">Bad Number</label>
                                          </div>
                                          <ErrorMessage
                                            name="activityType"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>

                                     
                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="addedDate">
                                              Log Date
                                            </Label>
                                            <Flatpickr
                                              className={
                                                "form-control" +
                                                (errors.addedDate && touched.addedDate
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder=""
                                              value={values.addedDate}
                                              onChange={(value) => setFieldValue('addedDate', value[0])}
                                              options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d"
                                              }}
                                            />
                                            <ErrorMessage
                                              name="addedDate"
                                              component="div"
                                              className="invalid-feedback"
                                            />

                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="callNote">
                                              Add Message
                                            </Label>
                                            <SafeField
                                              name="callNote"
                                              onChange={handleChange}
                                              as="textarea"

                                              className="form-control"

                                              id="callNote"

                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                                    </Form>
                                  )}
                                </Formik>
                                 {calllogs && calllogs.length > 0 ? (
                                                              <>
                                <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(calllogs, (callLog, callkey) => (

                                    <li className="event-list eventlist" key={"_call_" + callkey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{callLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>
                                </>
                                ): null }
                              </div>
                            </TabPane>
                            <TabPane tabId="6">
                              <div className="tabContent">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    actionType: 'Email Sent',
                                    addedDate: new Date(),
                                    refId: lead.leadId

                                  }}
                                  validationSchema={Yup.object().shape({
                                    actionType: Yup.string().required(
                                      "Please Select Action"
                                    )
                                  })}

                                  onSubmit={values => {
                                    onAddEmailLog(values)
                                   
                                  }}
                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                      className="needs-validation"
                                    >

                                      <Row className="mt20 mb20">
                                              <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="builderName">
                                            {this.props.t("Select Type")}
                                          </Label>
                                          <div className="clearfix"></div>
                                          <div className="btn-group" role="group">
                                            <SafeField type="radio" className="btn-check"
                                              name="actionType" id="actionType_e_1"
                                              value='Email Sent'
                                              checked={values.actionType === 'Email Sent'}
                                              onChange={() => {
                                                setFieldValue("actionType", 'Email Sent')
                                               
                                              }}
                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="actionType_e_1">Email Sent</label>

                                            <SafeField type="radio" className="btn-check"   name="actionType" id="actionType_e_2" value='Email Received'
                                              checked={values.actionType === 'Email Received'}

                                              onChange={() => {
                                                setFieldValue("actionType", 'Email Received')
                                
                                              }}

                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="actionType_e_2">Email Received</label>

                                            <SafeField type="radio" className="btn-check" name="actionType" id="actionType_e_3"
                                              value={4}
                                              checked={values.actionType === 'Email Bounced'}

                                              onChange={() => {
                                               
                                                setFieldValue("actionType", "Email Bounced")
                                              }}
                                              autoComplete="off" />
                                            <label className="btn btn-outline-secondary" htmlFor="actionType_e_3">Email Bounced</label>

                                           
                                          </div>
                                          <ErrorMessage
                                            name="activityType"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>


                                      

                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="addedDate">
                                              Log Date
                                            </Label>
                                            <Flatpickr
                                              className={
                                                "form-control" +
                                                (errors.addedDate && touched.addedDate
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder=""
                                              value={values.addedDate}
                                              onChange={(value) => setFieldValue('addedDate', value[0])}
                                              options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d"
                                              }}
                                            />
                                            <ErrorMessage
                                              name="addedDate"
                                              component="div"
                                              className="invalid-feedback"
                                            />

                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="remarks">
                                              Add Message
                                            </Label>
                                            <SafeField
                                              name="remarks"
                                              onChange={handleChange}
                                              as="textarea"

                                              className="form-control"

                                              id="remarks"

                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                                    </Form>
                                  )}
                                </Formik>
                                 {emaillogs && emaillogs.length > 0 ? (
                                                              <>
                                <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(emaillogs, (emailLog, emailkey) => (

                                    <li className="event-list eventlist" key={"_email_" + emailkey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{emailLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>
                                </>
                                 ): null }
                              </div>
                            </TabPane>
                          </TabContent>



                        </OffcanvasBody>
                      </Offcanvas>

                      <Offcanvas
                        isOpen={this.state.isAddNew}
                        direction="end"
                        toggle={this.toggleAddNew}
                        style={{ width: 800 }}
                      >
                        <OffcanvasHeader toggle={this.toggleAddNew}>
                          New Lead
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <CreateLead toggleAddNew={this.toggleAddNew} />
                        </OffcanvasBody>
                      </Offcanvas>
                    
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
LeadListShort.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  gridLoading: PropTypes.object,
  history: PropTypes.object,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  leadNotes: PropTypes.array,
  onGetFollowLead: PropTypes.func,
  leadFollows: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onAddCallLog: PropTypes.func,
  onAddEmailLog: PropTypes.func,
  onSendWorksheetEmailLog: PropTypes.func,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  onGetAllLeads: PropTypes.func,
  allLeads: PropTypes.array,
  onDeleteLead: PropTypes.func,
  userdetail:PropTypes.object,
  campaignemaillists:PropTypes.array,
  onGetCampaignEmailList:PropTypes.func,
}
const mapStateToProps = ({ leads, projectleads, AppoinmentObject }) => (

  {
    gridLoading: leads.gridLoading,
    allLeads: leads.allLeads,
    leadNotes: leads.leadNotes,
    activities: leads.activities,
    leadFollows: projectleads.leadFollows,
    calllogs: leads.calllogs,
    emaillogs: leads.emaillogs,
     campaignemaillists:AppoinmentObject.campaignemaillists,


  })
const mapDispatchToProps = dispatch => ({


  onGetAllLeads: (agentId, collectionId) => dispatch(getLeads(agentId, collectionId)),
  onAddLeadNote: (data) => dispatch(addLeadNoteTab(data)),
  onGetNoteLead: (leadId) => dispatch(getNoteLeadTab(leadId)),
  onGetFollowLead: (leadId) => dispatch(getActivityFollowUp(leadId)),
  onAddLeadFollowUp: (data) => dispatch(addActivityFollowUp(data)),
  onAddCallLog: (data) => dispatch(addLeadCallLog(data)),
  onGetLeadCallLog: (leadId) => dispatch(getLeadCallLog(leadId)),
  onAddEmailLog: (data) => dispatch(addLeadEmailLog(data)),
  onGetLeadEmailLog: (leadId) => dispatch(getLeadEmailLog(leadId)),
  onGetAllActLead: (leadId) => dispatch(getAllActLeadTab(leadId)),
  onDeleteLead: (id) => dispatch(deleteLead(id)),
  onGetCampaignEmailList:(agentId) => dispatch(getCampaignEmailList(agentId)),

})
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeadListShort))